/**
 * This is a fragment of the Post object model.
 */

import gql from 'graphql-tag';
import FRAGMENT_CATEGORY_CHILDREN_MODEL from './fragmentCategoryChildrenModel';
import FRAGMENT_FEATURED_IMAGE_MODEL from './fragmentFeaturedImageModel';
import FRAGMENT_CONTENT_NODE_BASIC_MODEL from './fragmentContentNodeBasicModel';

const FRAGMENT_PAGE_OBJECT_MODEL = gql`
  ${FRAGMENT_CATEGORY_CHILDREN_MODEL}
  ${FRAGMENT_FEATURED_IMAGE_MODEL}
  ${FRAGMENT_CONTENT_NODE_BASIC_MODEL}

  fragment PageObjectModel on Page {
    paywall {
      premium
    }
    ...ContentNodeBasicModel
    title
    slug
    excerpt
    content
    featuredImage {
      node {
        ...FeaturedImageModel
      }
    }
    categories {
      nodes {
        ...CategoryChildrenModel
      }
    }
  }
`;

export default FRAGMENT_PAGE_OBJECT_MODEL;
